import {BaseModel} from '../base/BaseModel';

/**
 * @class StressModel
 * @extends BaseModel
 *
 * @property {object} attributes
 */
export class StressModel extends BaseModel {

    initialize () {

        this.microservice = 'md2';
        this.resource = 'stresses';
    }

    get defaults () {

        return {
            name: undefined,
            eppoCode: undefined,
            scientificName: undefined,
            stressTypeUuid: undefined,
            stressType: undefined,
            taxonomyUuid: undefined
        };
    }

    static get TYPES () {

        return {
            PLANT: 'f1cd78b6-a959-7247-9d12-d4260283f275'
        };
    }

    static get WEIGHT () {

        return {
            HIGH: 'HIGH',
            MEDIUM: 'MEDIUM'
        };
    }

    static get TAXONOMY () {

        return {
            GENUS: 'GENUS',
            SPECIE: 'SPECIE'
        };
    }
}


// WEBPACK FOOTER //
// ./shared/model/md/StressModel.js